import getConfig from 'next/config';
import { forwardRef } from 'react';
import { LocalStorageService, parseJwt } from '../../helper';

type CryptoBuyFormProps = {
  amountf: number;
  item_name: string;
  item_desc: string;
  invoice: string;
};

export const CryptoBuyForm = forwardRef<HTMLFormElement, CryptoBuyFormProps>(
  ({ amountf, item_name, item_desc, invoice }, ref) => {
    const {
      publicRuntimeConfig: { authApi, coinpaymentsUrl },
    } = getConfig();

    const DEFAULT_LANG = 'en';
    const lng = LocalStorageService.get('language') || DEFAULT_LANG;
    const { userId } = parseJwt();

    return (
      <form
        action="https://www.coinpayments.net/index.php"
        method="post"
        ref={ref}
        style={{ display: 'none' }}
      >
        <input type="hidden" readOnly name="cmd" value="_pay_simple" />
        <input type="hidden" readOnly name="reset" value="1" />
        <input type="hidden" readOnly name="merchant" value="892a396f3510df3e5e12e22777444793" />
        <input type="hidden" readOnly name="item_name" value={item_name} />
        <input type="hidden" readOnly name="item_desc" value={item_desc} />
        <input type="hidden" readOnly name="invoice" value={invoice} />
        <input type="hidden" readOnly name="custom" value={userId} />
        <input type="hidden" readOnly name="currency" value="USD" />
        <input type="hidden" readOnly name="amountf" value={amountf} />
        <input type="hidden" readOnly name="want_shipping" value="0" />
        <input
          readOnly
          type="hidden"
          name="success_url"
          value={`${window.location.origin}/${lng}/terminal/checkout/success?sessionId={CHECKOUT_SESSION_ID}`}
        />
        <input
          readOnly
          type="hidden"
          name="cancel_url"
          value={`${window.location.origin}/${lng}/terminal/checkout/cancel?sessionId={CHECKOUT_SESSION_ID}`}
        />
        <input readOnly type="hidden" name="ipn_url" value={authApi + coinpaymentsUrl} />
      </form>
    );
  }
);
